/**
 * Configuration Puck pour les templates web (admin) — ASSEMBLEUR.
 * La config de chaque bloc vit à côté de son composant :
 * blocks/web/<Bloc>/<Bloc>.puck.jsx
 * Composants : SiteHeader, SiteFooter, LoginPage, LoadingPage.
 */

import siteHeaderConfig from '../blocks/web/SiteHeader/SiteHeader.puck';
import siteFooterConfig from '../blocks/web/SiteFooter/SiteFooter.puck';
import loginPageConfig from '../blocks/web/LoginPage/LoginPage.puck';
import loadingPageConfig from '../blocks/web/LoadingPage/LoadingPage.puck';

export const puckTemplateConfig = {
  categories: {
    "Menu d'en tête": { components: ['SiteHeader'] },
    'Pied de page': { components: ['SiteFooter'] },
    Authentification: { components: ['LoginPage', 'LoadingPage'] },
  },

  components: {
    SiteHeader: siteHeaderConfig,
    SiteFooter: siteFooterConfig,
    LoginPage: loginPageConfig,
    LoadingPage: loadingPageConfig,
  },
};
